// extracted by mini-css-extract-plugin
export var aboveInput = "_ld-0";
export var actionButton = "_ld-5";
export var actionButtonContainer = "_ld-1";
export var actionIcon = "_ld-6";
export var aiInfoContainer = "_ld-2";
export var attachmentWrapper = "_ld-7";
export var bold = "_ld-3";
export var checkIcon = "_ld-8";
export var clickingRecipientBar = "_ld-11";
export var commentThreadSwitch = "_ld-a";
export var draftImage = "_ld-b";
export var draftImageContainer = "_ld-c";
export var draftImages = "_ld-e";
export var editButton = "_ld-g";
export var editor = "_ld-f";
export var editorContainer = "_ld-y";
export var editorErrorTooltipWrapper = "_ld-9";
export var headerDivider = "_ld-h";
export var icon = "_ld-i";
export var info = "_ld-j";
export var internal = "_ld-n";
export var internalDivider = "_ld-k";
export var internalMessage = "_ld-l";
export var messageInputCard = "_ld-m";
export var messageInputForm = "_ld-o";
export var messageInputFormInternal = "_ld-p";
export var options = "_ld-q";
export var publicMessageCustomer = "_ld-s";
export var publicMessageMerchant = "_ld-r";
export var removeImageButton = "_ld-d";
export var replyButtons = "_ld-t";
export var showSignatureButton = "_ld-u";
export var spinner = "_ld-v";
export var verticalButtonDivider = "_ld-4";
export var visibilitySelector = "_ld-w";
export var warning = "_ld-x";
export var wrappingText = "_ld-z";
export var writingInternalNoteTopBorder = "_ld-10";